//TODO: needs to refactor the code
export class ErrorHandlerHelper {
    rawError;
    errorObject = {
      code: 500,
      data: undefined,
      error: 'Unknown error',
      isError: true,
      message: 'Something went wrong! Please try again.',
      timestamp: Date.now(),
    };
    constructor(err) {
      this.rawError = err;
      this.setError();
    }
  
    setError = () => {
      this.errorObject.code = this.rawError && this.rawError.code ? this.rawError.code : this.errorObject.code;
      this.errorObject.timestamp = Date.now();
      this.errorObject.data = '';
      if (this.rawError && this.rawError.data && typeof this.rawError.data === 'object') {
        this.errorObject.data = this.rawError.data?.body || this.rawError.data?.details || this.rawError.data;
      }
      this.errorObject.message = this?.rawError?.response?.data?.message 
      this.errorObject.error = `${this.errorObject.error} -  ${this.rawError?.code} (${this.rawError.data?.status})`;
    };
  }
  